import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { BusinessFunctionService } from "../services/businessfunction.service";
import { Observable } from "rxjs";

@Injectable()
export class LastUpdateDateResolver implements Resolve<Date> {

    constructor(private businessFunctionService: BusinessFunctionService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<Date> {
        // todo: route.params["id"] - explicitly passsing it as 4 at the moment.
        return this.businessFunctionService.getLastUdpatedDate();
    }
}
